/* unplugin-vue-components disabled */import { render } from "./PersonalDetail.vue?vue&type=template&id=6d2e4e3f&scoped=true&ts=true"
import script from "./PersonalDetail.vue?vue&type=script&lang=ts"
export * from "./PersonalDetail.vue?vue&type=script&lang=ts"

import "./PersonalDetail.vue?vue&type=style&index=0&id=6d2e4e3f&lang=less&scoped=true"

import exportComponent from "D:\\项目\\blueSkyReportForm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d2e4e3f"]])

export default __exports__